import { Component, OnInit } from '@angular/core';
import { RemessaService } from '../../../../../shared/services/remessa/remessa.service';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';
import * as moment from 'moment';
import { BoletoService } from '../../../../../shared/services/boleto/boleto.service';

import { environment } from '../../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-todos-boletos',
  templateUrl: './todos-boletos.component.html',
  styleUrls: ['./todos-boletos.component.scss']
})
export class TodosBoletosComponent implements OnInit {
  public boletos: any[];
  public boleto: any;
  public table: any = null;
  public error = false;
  public loaded = false;
  public showModal = false;

  constructor(
    private boletoService: BoletoService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.getBoletos();
  }

  getBoletos() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.boletoService.obterBoletos(user.PersonId).subscribe((data: any) => {

      data.sort(function(a, b) {
        if (a.NumeroDocumento < b.NumeroDocumento) { return -1; }
        if (a.NumeroDocumento > b.NumeroDocumento) { return 1; }
        return 0;
      });

      data.reverse();

      data.forEach((boleto) => {
        boleto.DataVencimento = moment(boleto.DataVencimento).format('DD/MM/YYYY');
        boleto.Valor = boleto.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      });

      this.boletos = data;

      this.showData();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;
    this.table = $('#master-detail-table-boletos').DataTable({
      scrollX: true,
      destroy: true,
      paging: false,
      searching: false,
      processing: false,
      info: true,
      data: self.boletos,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function() {
        self.loaded = true;

        if (self.boletos && self.boletos.length === 0) {
          $('#master-detail-table-boletos_info').html('0 - 0 de 0');
        }
      },
      columns: [
        { title: 'Nome do Cliente', data: 'SacadoNome' },
        { title: 'Vencimento', data: 'DataVencimento' },
        { title: 'Valor', data: 'Valor' },
        {
          title: '',
          class: 'download-remessa',
          data: null,
          orderable: false,
          render: function(data) {
            const url = environment.production ? 'https://' + data.BoletoUrl : 'https://s3.amazonaws.com/' + data.BoletoUrl;

            return '<a href="' + url + '" target="_blank">' +
                     '<i class="fa fa-eye" style="font-size: 20px;"></i>' +
                   '</a>';
          },
        },
      ],
    });

    this.rowClickListener();

    $('#master-detail-table-boletos').on('page.dt', function() {
      self.rowClickListener();
    });
  }

  rowClickListener() {
    const self = this;
    $('#master-detail-table-boletos tbody').on('click', 'tr', function(e) {
      if (e.target.className !== 'fa fa-eye') {
        const data = self.table.row(this).data();
        self.boleto = data;
        self.showModal = true;
      }
    });
  }

  eventClose() {
    this.showModal = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/boletos/todos-boletos/todos-boletos.component.ts